import React, { Component } from 'react';
import LogoAndTitleDiv from './LogoAndTitleDiv'
import RecordSearchArea from './RecordSearchArea'
import './UpBanner.css'



class UpBanner extends Component {
    constructor(props){
        super(props)
        this.state = {
            basicSearchWord:"查詢全欄位，可用 AND、OR 布林邏輯",
            searchInfo:null,
            //count:0,
            url:"/"
        }
    }

    componentDidMount(){
        console.log("UpBanner did mount")
        
    }

    getLogoClick=(msg)=>{
        this.setState({
            searchInfo:null,
            redirect:false
        },()=>{
            this.props.getLogoClick(msg)
        })
    }

    

    

    render(){

        
        return(
           
            <div className="UpBannerBody">
                <LogoAndTitleDiv />
                <RecordSearchArea />
            </div>
        )
    }
}

export default UpBanner
